import { policiesIsAccepted } from './utils/cookies'

export class Policies {

  constructor() {
    this.page = $(document)
  }

  loadModalListener() {
    this.page
    .ready(() => {
      policiesIsAccepted() ? 
        $('.cookieModal').css('display', 'none') :
        $('.cookieModal').css('display', 'unset')
    })
  }

  static policeModalListener() {
    const policies = new Policies()
    policies.loadModalListener()
  }
}